export default __webpack_public_path__ + "572c229c2db270fe2d313af7ad9d2d94.png";